Pluswerk.PlusProject.Content = Pluswerk.PlusProject.Content || {};

/**
 * PriceFootnoteController
 *
 * @author Benjamin Stiber <benjamin.stiber@pluswerk.ag>
 */
Pluswerk.PlusProject.Content.PriceFootnoteController = function () {
  var $pricesWrapper = $('.js-prices');
  var $footnoteWrapper = $('.js-footnotes');
  var $indexElement = $('.js-footnote-index');

  /**
   * initOnce
   */
  var initOnce = function () {
    $(document).ready(function () {
      $pricesWrapper.find($indexElement).each(function (index) {
        this.innerHTML = '<sup>' + (index + 1) + '</sup>';
      });
      $footnoteWrapper.find($indexElement).each(function (index) {
        this.innerHTML = '<sup>' + (index + 1) + '</sup>';
      });
    });
  };

  initOnce();
};
